

import qs from 'qs';
import url from 'url';
import * as utilObject from './object';

const LOCATION_HREF = utilObject.get(window, 'location.href', '');
const LOCATION_SEARCH = utilObject.get(window, 'location.search', '');

export default qs;

/**
 * 从 URL 中解析出 query 对象
 *
 * @export
 * @param {string} [url=LOCATION_HREF]
 * @returns {object}
 */
export function parseUrl(_url = LOCATION_HREF) {
  const query = url.parse(_url).query;
  return qs.parse(query);
}

/**
 * 从 location.search 中解析出 query 对象
 *
 * @export
 * @param {string} [search=LOCATION_SEARCH]
 * @returns {object}
 */
export function parseSearch(search = LOCATION_SEARCH) {
  const query = search.split('?')[1] || '';
  return qs.parse(query);
}
